import axios from 'axios';
import { PRICE_VERSION_VARIATION_ENDPOINT } from '../../../common/endpoints';

export async function updateDepreciationYear(rowToEdit){
    try{
        const {id, value, year, modelVersionPrice} = rowToEdit
        const percentageRow = Number(value.replace(',','.'))
        const body = { depreciation: percentageRow, year, modelVersionPrice}
        return await axios.put(`${PRICE_VERSION_VARIATION_ENDPOINT}/${id}`, body)
    }catch(error){
       throw error.response.data
    }
}